<div class="bg-white border-bottom px-4 py-3">
    <div class="container-fluid">
        <h5 class="mb-3 fw-semibold">Tender Setup <span *ngIf="tender?.name"> - {{tender.name}}</span></h5>
        <div class="stepper">

            <div class="d-flex align-items-center">
                <div class="stepper-item"
                     [class.active]="isCurrentLink(tenderSteps.DETAILS)"
                     [class.completed]="1 <= stepsCompleted"
                     (click)="goToStep(tenderSteps.DETAILS)">
                    <div class="stepper-icon"><i class="bi bi-sliders2"></i></div>
                    <span>Set Parameters</span>
                </div>
                <i class="bi bi-chevron-right stepper-arrow"></i>
            </div>

            <div class="d-flex align-items-center">
                <div class="stepper-item"
                     [class.active]="isCurrentLink(tenderSteps.CONTRACTS)"
                     [class.completed]="2 <= stepsCompleted"
                     (click)="goToStep(tenderSteps.CONTRACTS)">
                    <div class="stepper-icon"><i class="bi bi-geo-alt-fill"></i></div>
                    <span>Add Locations</span>
                </div>
                <i class="bi bi-chevron-right stepper-arrow"></i>
            </div>

            <div class="d-flex align-items-center">
                <div class="stepper-item"
                     [class.active]="isCurrentLink(tenderSteps.SUPPLIERS)"
                     [class.completed]="3 <= stepsCompleted"
                     (click)="goToStep(tenderSteps.SUPPLIERS)">
                    <div class="stepper-icon"><i class="bi bi-people-fill"></i></div>
                    <span>Invite Suppliers</span>
                </div>
                <i class="bi bi-chevron-right stepper-arrow"></i>
            </div>

            <div class="d-flex align-items-center">
                <div class="stepper-item"
                     [class.active]="isCurrentLink(tenderSteps.LAUNCH)"
                     [class.completed]="4 <= stepsCompleted"
                     (click)="goToStep(tenderSteps.LAUNCH)">
                    <div class="stepper-icon"><i class="bi bi-check2-all"></i></div>
                    <span>Review & Launch</span>
                </div>
            </div>

        </div>
    </div>
</div>
